import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { StockBalance, StockBalanceCreate, StockBalanceFilter } from '../data/stockBalance';

export function createStockBalanceService(client: AxiosInstance) {
  return createCrudService<StockBalance, StockBalanceCreate, StockBalanceFilter>(
    client,
    '/purchase/StockBalance',
    'id',
  );
}

export type StockBalanceService = CrudService<StockBalance, StockBalanceCreate, StockBalanceFilter>;
